import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import "moment-timezone";
import { FaChartBar } from "react-icons/fa";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { months } from "../utils/rawData/dateValues";
import { ResponsivePie } from '@nivo/pie';
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import Tooltip from "../components/ui/ToolTip";


function EstadisticasTrabajador() {

  const user = useSelector((state) => state.auth.user);
  
  const [isLoading, setIsLoading] = useState(false)

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const [record, setRecord] = useState([]);
  const [incidences, setIncidences] = useState([]);
  const [payment, setPayment] = useState({})

  console.log(record)

  const getData = async () => {
    try {
      setIsLoading(true)
      const response = await axios.get(`${BACKEND}/api/metaDataUsers/getWorkersData?month=${month}&year=${year}&idWorker=${user.id}`)
      setRecord(response.data.workers)
    } catch (error) {
      toast.error("Error obteniendo la data: " + error)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchPayment = async () => {
    try {
        const response = await axios.get(`${BACKEND}/api/pagosTrabajadores?where[worker][equals]=${user.id}&where[month][equals]=${month}&where[year][equals]=${year}`);
        setPayment(response.data.docs[0]);
    } catch (error) {
        toast.error("Error obteniendo los registros: " + error);
    }
  };

  const getIncidences = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/incidencias?where[trabajador][equals]=${user.id}&where[month][equals]=${month}&where[year][equals]=${year}`);
      setIncidences(response.data.docs)
    } catch (error) {
      toast.error("Error obteniendo las incidencias: " + error)
    }
  }

  useEffect(() => {
    getData()
    fetchPayment()
    getIncidences()
  }, [])

  useEffect(() => {
    getData()
    fetchPayment()
    getIncidences()
  }, [month, year])

  const paymentStatusColor = {
    "Pagado": "text-green-500",
    "Pendiente": "text-yellow-500",
    "Cancelado": "text-red-500"
  }

  return (
    <div className="w-full flex flex-col h-screen">
      
      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="flex flex-row justify-start">
            <div className="flex items-center gap-4 p-4">
              <FaChartBar className="text-gray-700 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-700">Mis estadísticas</h2>
            </div>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Mes:</span>
              <select
                id="filtroFechaInicio"
                name="filtroFechaInicio"
                value={month}
                onChange={(e) => setMonth(Number(e.target.value))}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                {months.map((monthOption) => (
                  <option
                    key={monthOption.value}
                    value={monthOption.value}
                  >
                    {monthOption.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Año:</span>
              <select
                type="date"
                id="filtroFechaFin"
                name="filtroFechaFin"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
              </select>
            </div>
          </div>

        </div>
      </div>

      {/* Body */}
      <div className="flex flex-row w-full h-full">
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <div className="flex flex-col md:flex-row w-full h-full gap-4 p-4">

            {/* Gráficos */}
            <div className="flex flex-col w-full md:w-1/2 gap-4">

              <div className="flex flex-col md:flex-row w-full gap-4">

                {/* Gráfico de Registros */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Tardanzas y minutos extra</h3>
                  <span className="text-xs text-gray-500">Horas trabajadas: {record[0]?.hoursWorked}</span>
                  {record[0]?.hoursWorked !== "0h 0m" ? (
                    <ResponsivePie
                      data={[
                        {
                          id: 'Minutos de Tardanza',
                          label: 'Minutos de tardanza',
                          //value: record[0].workTimeByDay.filter(r => r.tardanza > 0).length,
                          value: record[0]?.totalTardanza,
                          color: '#f32b2b'
                        },
                        {
                          id: 'Minutos extra',
                          label: 'Minutos extra',
                          //value: record.filter(r => r.status === 'late').length,
                          value: record[0]?.totalExtra,
                          color: '#369ff4'
                        }
                      ]}
                      margin={{ top: 40, right: 60, bottom: 60, left: 60 }}
                      innerRadius={0.5}
                      padAngle={0.7}
                      cornerRadius={3}
                      activeOuterRadiusOffset={8}
                      colors={{ scheme: 'nivo' }}
                      borderWidth={1}
                      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                      enableArcLinkLabels={false}
                      arcLinkLabelsSkipAngle={5}
                      arcLinkLabelsTextColor="#333333"
                      arcLabelsSkipAngle={5}
                      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                    />
                  ) : (
                    <NoDataScreen text="No hay registros" />
                  )}
                </div>

                {/* Gráfico de Incidencias */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Incidencias</h3>
                  <span className="text-xs text-gray-500">Total de incidencias: {incidences.length}</span>
                  {incidences.length > 0 ? (
                    <ResponsivePie
                      data={[
                        {
                          id: 'Leve',
                          label: 'Leve',
                          value: incidences.filter(i => i.gravedad === 'Leve').length,
                          color: '#2196F3'
                        },
                        {
                          id: 'Moderada',
                          label: 'Moderada',
                          value: incidences.filter(i => i.gravedad === 'Moderada').length,
                          color: '#FF5722'
                        },
                        {
                          id: 'Grave',
                          label: 'Grave',
                          value: incidences.filter(i => i.gravedad === 'Grave').length,
                          color: '#FF5722'
                        },
                        {
                          id: 'Muy grave',
                          label: 'Muy grave',
                          value: incidences.filter(i => i.gravedad === 'Muy grave').length,
                          color: '#FF5722'
                        }
                      ]}
                      margin={{ top: 40, right: 60, bottom: 60, left: 60 }}
                      innerRadius={0.5}
                      padAngle={0.7}
                      cornerRadius={3}
                      activeOuterRadiusOffset={8}
                      colors={{ scheme: 'nivo' }}
                      borderWidth={1}
                      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                      enableArcLinkLabels={false}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                    />
                  ) : (
                    <NoDataScreen text="No hay incidencias" />
                  )}
                </div>

              </div>

              <div className="flex flex-col md:flex-row w-full gap-4">

                {/* Gráfico de Asistencias */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Asistencias</h3>
                  <span className="text-xs text-gray-500">Asistencias: {record[0]?.workTimeByDay.length}</span>
                  {record[0]?.assistances !== 0 ? (
                    <ResponsivePie
                      data={[
                        {
                          id: 'Asistencias',
                          label: 'Asistencias',
                          value: record[0]?.workTimeByDay.filter(r => r.tardanza === 0).length,
                          color: '#f32b2b'
                        },
                        {
                          id: 'Tardanzas',
                          label: 'Tardanzas',
                          value: record[0]?.workTimeByDay.filter(r => r.tardanza > 0).length,
                          color: '#369ff4'
                        }
                      ]}
                      margin={{ top: 40, right: 60, bottom: 60, left: 60 }}
                      innerRadius={0.5}
                      padAngle={0.7}
                      cornerRadius={3}
                      activeOuterRadiusOffset={8}
                      colors={{ scheme: 'nivo' }}
                      borderWidth={1}
                      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                      enableArcLinkLabels={false}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                    />
                  ) : (
                    <NoDataScreen text="No hay registros" />
                  )}
                </div>

                {/* Tabla de Incidencias */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Incidencias</h3>
                  <span className="text-xs text-gray-500">Total descuentos: S/. {incidences.reduce((acc, i) => acc + (i.descuento ? i.descuento : 0), 0)}</span>
                  {incidences.length > 0 ? (
                    <div className="flex flex-col gap-2 flex-grow h-[calc(100%-3rem)] overflow-y-auto">
                      {incidences.map((i, index) => (
                        <div key={index} className="flex flex-col bg-white rounded-lg shadow-sm p-3 hover:bg-gray-50 border border-gray-100">
                          <div className="flex justify-between items-center mb-1">
                            <h4 className="text-[10px] font-medium text-gray-800">{i.titulo}</h4>
                            <span className={`px-2 py-1 text-[10px] font-semibold rounded-full 
                              ${i.gravedad === 'Leve' ? 'bg-green-100 text-green-800' : 
                                i.gravedad === 'Moderada' ? 'bg-yellow-100 text-yellow-800' :
                                i.gravedad === 'Grave' ? 'bg-orange-100 text-orange-800' :
                                'bg-gray-100 text-gray-800'}`}>
                              {i.gravedad}
                            </span>
                          </div>
                          <div>
                            <Tooltip content={i.comentario}>
                              <span className="text-[10px] text-gray-500 hover:cursor-pointer hover:underline">Detalles</span>
                            </Tooltip>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-[10px] text-gray-500">
                              {moment(i.fecha).format('DD/MM/YYYY')}
                            </span>
                            <span className="text-[10px] text-red-600">
                              Descuento: S/. {i.descuento || 0}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <NoDataScreen text="No hay incidencias" />
                  )}
                </div>

              </div>
            
            </div>
            
            {/* Información de Pago */}
            <div className="w-full md:w-1/2">
              <div className="flex flex-col h-full w-full rounded-md shadow-md p-4 gap-4 border border-gray-200">
                
                <h3 className="text-sm font-semibold">
                  Información de Pago -{" "}
                  <span className={paymentStatusColor[payment?.status]}>
                    {payment?.status}
                  </span>
                </h3>

                {/* Resumen */}
                <div className="grid grid-cols-2 gap-4">
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Monto</p>
                    <p className="text-sm font-bold text-gray-800">S/. {payment?.amount || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Días Trabajados</p>
                    <p className="text-sm font-bold text-gray-800">{record[0]?.workTimeByDay.length || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Incidencias</p>
                    <p className="text-sm font-bold text-gray-800">{incidences?.length || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Descuentos</p>
                    <p className="text-sm font-bold text-gray-800">
                      S/. {incidences.reduce((acc, i) => acc + (i.descuento || 0), 0)}
                    </p>
                  </div>
                </div>

                {/* Imágenes o mensaje */}
                <div className="flex w-full justify-center items-center rounded-md p-4 overflow-x-auto">
                  {payment?.status === "Pagado" ? (
                    payment?.images?.length > 0 ? (
                      <div className="flex gap-4">
                        {payment.images.map((image, index) => (
                          <img
                            key={index}
                            src={image.url}
                            alt={`Pago ${index + 1}`}
                            className="max-h-[500px] rounded shadow object-contain"
                          />
                        ))}
                      </div>
                    ) : (
                      <NoDataScreen text="No hay imágenes" />
                    )
                  ) : (
                    <NoDataScreen text="Aún no pagan 😔" />
                  )}
                </div>
              </div>
            </div>

          </div>
        )}
      </div>

    </div>
  );
}

export default EstadisticasTrabajador;
